// GENERATED FILE — do not edit directly.
// Source of truth: packages/rbac-core/. Regenerate with:
//   node scripts/sync-rbac-core.js

export const ROLES = ["OPERATOR","ADMIN","MANAGER","SUPER_ADMIN"];

export const ROLE_HIERARCHY = {
  "OPERATOR": 1,
  "ADMIN": 2,
  "MANAGER": 3,
  "SUPER_ADMIN": 4
};

export const MODULI_NON_PRODUZIONE = new Set([
  "effeisbuck",
  "helpdesk",
  "module_salesforce_casi_pneumatici"
]);

export const CATALOGO = Object.freeze([
  {
    "codice": "vista.home",
    "percorso": "/home",
    "etichetta": "Home",
    "sezione": "Home",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.operatore.dashboard",
    "percorso": "/dashboard",
    "etichetta": "Dashboard Produzione",
    "sezione": "Operatore",
    "modulo": null,
    "piuModuliProduzione": true,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.operatore.pratiche",
    "percorso": "/pratiche",
    "etichetta": "Pratiche",
    "sezione": "Operatore",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.news.prima_pagina",
    "percorso": "/news",
    "etichetta": "Prima pagina",
    "sezione": "NEWS",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.effeisbuck.bacheca",
    "percorso": "/effeisbuck",
    "etichetta": "Bacheca",
    "sezione": "EFFEISBUCK",
    "modulo": "effeisbuck",
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.effeisbuck.profilo",
    "percorso": "/effeisbuck/profilo",
    "etichetta": "Mio profilo",
    "sezione": "EFFEISBUCK",
    "modulo": "effeisbuck",
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.helpdesk.coda",
    "percorso": "/helpdesk",
    "etichetta": "Coda",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.helpdesk.board",
    "percorso": "/helpdesk/board",
    "etichetta": "Board",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.helpdesk.statistiche",
    "percorso": "/helpdesk/stats",
    "etichetta": "Statistiche",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.helpdesk.impostazioni",
    "percorso": "/helpdesk/settings",
    "etichetta": "Impostazioni",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.rubrica",
    "percorso": "/rubrica",
    "etichetta": "Rubrica",
    "sezione": "Rubrica",
    "modulo": null,
    "almenoUnModulo": true,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.admin.classifica",
    "percorso": "/admin/leaderboard",
    "etichetta": "Classifica",
    "sezione": "Amministrazione",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.admin.analisi",
    "percorso": "/admin/analisi",
    "etichetta": "Analisi Dati",
    "sezione": "Amministrazione",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.admin.moduli",
    "percorso": "/admin/moduli",
    "etichetta": "Moduli",
    "sezione": "Amministrazione",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.admin.archivio",
    "percorso": "/admin/archivio",
    "etichetta": "Archivio",
    "sezione": "Amministrazione",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.ferie",
    "percorso": "/workforce/ferie",
    "etichetta": "Ferie",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.presenze",
    "percorso": "/workforce/presenze",
    "etichetta": "Presenze",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.festivita",
    "percorso": "/workforce/festivita",
    "etichetta": "Festività",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.saldi",
    "percorso": "/workforce/saldi",
    "etichetta": "Saldi",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.banca_ore",
    "percorso": "/workforce/banca-ore",
    "etichetta": "Banca ore",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "OPERATOR",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.presenze_team",
    "percorso": "/workforce/presenze-team",
    "etichetta": "Presenze Team",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.blocchi",
    "percorso": "/workforce/blocchi",
    "etichetta": "Blocchi operativi",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.gruppi",
    "percorso": "/workforce/gruppi",
    "etichetta": "Gruppi",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.costo_lavoro",
    "percorso": "/workforce/costo-lavoro",
    "etichetta": "Costo del lavoro",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.ccnl",
    "percorso": "/workforce/ccnl",
    "etichetta": "Regole CCNL",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.workforce.maturazioni",
    "percorso": "/workforce/maturazioni",
    "etichetta": "Maturazioni",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.admin.notifiche",
    "percorso": "/admin/notifiche",
    "etichetta": "Notifiche",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.utenti",
    "percorso": "/iam/utenti",
    "etichetta": "Gestione Utenti",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.ruoli",
    "percorso": "/iam/ruoli",
    "etichetta": "Ruoli",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.moduli",
    "percorso": "/iam/moduli",
    "etichetta": "Registro Moduli",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.sessioni",
    "percorso": "/iam/sessioni",
    "etichetta": "Log Sessioni",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.audit",
    "percorso": "/iam/audit",
    "etichetta": "Log Audit",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "MANAGER",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.email",
    "percorso": "/iam/email",
    "etichetta": "Log Email",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.permessi",
    "percorso": "/iam/permessi",
    "etichetta": "Profili e permessi",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.iam.gadget",
    "percorso": "/iam/gadget",
    "etichetta": "Gadget aziendali",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.branding",
    "percorso": "/config/branding",
    "etichetta": "Branding",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.template_email",
    "percorso": "/config/email-templates",
    "etichetta": "Template Email",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.smtp",
    "percorso": "/config/smtp",
    "etichetta": "Email SMTP",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.webrtc",
    "percorso": "/config/webrtc",
    "etichetta": "WebRTC Telefono",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.webhooks",
    "percorso": "/config/webhooks",
    "etichetta": "Webhooks",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.sicurezza",
    "percorso": "/config/security",
    "etichetta": "Sicurezza",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.rate_limit",
    "percorso": "/config/rate-limits",
    "etichetta": "Rate Limit",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.retention",
    "percorso": "/config/data-retention",
    "etichetta": "Data Retention",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.sistema",
    "percorso": "/config/system",
    "etichetta": "Stato Sistema",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.sso",
    "percorso": "/config/sso",
    "etichetta": "Single Sign-On",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "vista.config.ai",
    "percorso": "/config/ai",
    "etichetta": "Intelligenza Artificiale",
    "sezione": "Configurazione",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "tipo": "vista"
  },
  {
    "codice": "azione.helpdesk.chiudi_qualsiasi",
    "percorso": null,
    "etichetta": "Chiudere e riaprire qualsiasi ticket del team",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "SUPER_ADMIN",
    "implicaViste": [
      "vista.helpdesk.coda"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.helpdesk.assegna",
    "percorso": null,
    "etichetta": "Assegnare i ticket del team",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "SUPER_ADMIN",
    "implicaViste": [
      "vista.helpdesk.coda"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.helpdesk.priorita",
    "percorso": null,
    "etichetta": "Cambiare la priorità dei ticket del team",
    "sezione": "HELPDESK",
    "modulo": "helpdesk",
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "SUPER_ADMIN",
    "implicaViste": [
      "vista.helpdesk.coda"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.authority_bodywork.statistiche",
    "percorso": null,
    "etichetta": "Vedere ed esportare le statistiche del team",
    "sezione": "Operatore",
    "modulo": "module_authority_bodywork",
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "ADMIN",
    "implicaViste": [
      "vista.operatore.pratiche"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.authority_bodywork.cedolini",
    "percorso": null,
    "etichetta": "Correggere e inserire i cedolini delle persone del team",
    "sezione": "Operatore",
    "modulo": "module_authority_bodywork",
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "ADMIN",
    "implicaViste": [
      "vista.operatore.pratiche"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.authority_bodywork.target",
    "percorso": null,
    "etichetta": "Impostare il target base e la sua decorrenza",
    "sezione": "Operatore",
    "modulo": "module_authority_bodywork",
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "ADMIN",
    "implicaViste": [
      "vista.operatore.pratiche"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.workforce.gruppi.gestisci",
    "percorso": null,
    "etichetta": "Creare, modificare ed eliminare i gruppi",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "ADMIN",
    "apreAmbito": [
      "gruppi"
    ],
    "implicaViste": [
      "vista.workforce.gruppi"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.workforce.gruppi.membri",
    "percorso": null,
    "etichetta": "Aggiungere e togliere persone dai gruppi",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "ADMIN",
    "apreAmbito": [
      "gruppi",
      "utenti"
    ],
    "implicaViste": [
      "vista.workforce.gruppi"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.workforce.ccnl.regole",
    "percorso": null,
    "etichetta": "Pubblicare una nuova versione delle regole CCNL",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "implicaViste": [
      "vista.workforce.ccnl"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.workforce.ccnl.profili",
    "percorso": null,
    "etichetta": "Assegnare contratto, livello e data di assunzione",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.workforce.ccnl"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.admin.notifiche.invia",
    "percorso": null,
    "etichetta": "Inviare notifiche alle persone",
    "sezione": "Workforce",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "SUPER_ADMIN",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.admin.notifiche"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.crea",
    "percorso": null,
    "etichetta": "Creare nuove persone",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.modifica",
    "percorso": null,
    "etichetta": "Modificare i dati di una persona (non ruolo e moduli)",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.ruoli_moduli",
    "percorso": null,
    "etichetta": "Cambiare ruolo e moduli abilitati",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.stato",
    "percorso": null,
    "etichetta": "Sospendere e riattivare le persone",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.credenziali",
    "percorso": null,
    "etichetta": "Reimpostare credenziali e metodi di accesso",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.orario",
    "percorso": null,
    "etichetta": "Impostare l'orario di lavoro",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "MANAGER",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  },
  {
    "codice": "azione.iam.utenti.assenze",
    "percorso": null,
    "etichetta": "Registrare le assenze di una persona",
    "sezione": "IAM",
    "modulo": null,
    "ruoloMinimo": "SUPER_ADMIN",
    "ancheConRuolo": "ADMIN",
    "apreAmbito": [
      "utenti"
    ],
    "implicaViste": [
      "vista.iam.utenti"
    ],
    "tipo": "azione"
  }
]);

export const PER_CODICE = Object.freeze(Object.fromEntries(CATALOGO.map((v) => [v.codice, v])));

export function permessiDiRuolo(ruolo) {
  if (ruolo === 'SUPER_ADMIN') return CATALOGO.map((v) => v.codice);
  const mio = ROLE_HIERARCHY[ruolo] || 0;
  return CATALOGO.filter((v) => {
    const soglia = v.tipo === 'azione' ? (v.ancheConRuolo || v.ruoloMinimo) : v.ruoloMinimo;
    return mio >= (ROLE_HIERARCHY[soglia] || 0);
  }).map((v) => v.codice);
}

export function moduliProduzione(moduli = []) {
  if (!Array.isArray(moduli)) return [];
  return moduli.filter((m) => typeof m === 'string' && !MODULI_NON_PRODUZIONE.has(m));
}

export function canModifyAccount(caller, targetCurrentRole) {
  if (!caller) return false;
  if (caller.ruolo === 'SUPER_ADMIN') return true;
  return targetCurrentRole !== 'SUPER_ADMIN';
}

export function canAssignRole(caller, requestedRole) {
  if (!caller) return false;
  if (caller.ruolo === 'SUPER_ADMIN') return true;
  if (requestedRole === 'SUPER_ADMIN') return false;
  const mio = ROLE_HIERARCHY[caller.ruolo] || 0;
  const chiesto = ROLE_HIERARCHY[requestedRole] || 0;
  return chiesto > 0 && chiesto <= mio;
}
